<form id="formLogin" (submit)="formLogin()" ngNativeValidate *ngIf="isDev">
  <div class="d-flex align-items-center justify-content-center vh100">
      <section class="login d-flex">
          <!-- <div class="login__bg">
              <img src="assets/images/bg-login.png" alt="" class="img-fluid">
          </div> -->

          <div class="login__formulario d-flex flex-column align-items-center justify-content-center">
              <div class="login__formulario--titulo">
                  <p>iniciar sesión</p>
              </div>

              <div class="login__formulario--input">
                  <input name="idEmpleado" required type="number" class="form-control" placeholder="Id empleado" [(ngModel)]="idEmpleado">
              </div>

              <button [disabled]="disableBtn" type="submit" class="btn btn-primary ingresar">ingresar</button>
          </div>
      </section>
  </div>
</form>
